import Link from "../link";
import style from "./style.scss";

import { Fragment } from "preact";
import { useId } from "preact/hooks";
import { usePopup } from "../popup/context";
import Popup from "../popup";
import Editorial from "../editorial";
import namedRoutes from "../../settings/routes";

const ElectricalDisclosure = ({ brandSent = true }) => {
  const popup = usePopup();
  const modalTitleId = useId();

  const openDetails = (e) => {
    e.preventDefault();

    popup.showPopup(
      <Popup ariaLabelledBy={modalTitleId}>
        <div class={style.popupWrapper}>
          <Editorial>
            <h2 id={modalTitleId}>Electrical & Safety Disclaimer</h2>
            <p>
              All information, wiring diagrams, product reviews, and technical
              guides published by Tyson Matanich / Tyson's Gear Lab, whether on
              this website, in newsletters, in mobile apps, on social media
              channels, on third‑party platforms, or through any other
              distribution channel, are provided{" "}
              <strong>for informational purposes only</strong>. Tyson Matanich /
              Tyson's Gear Lab is an off‑grid enthusiast and DIYer,{" "}
              <strong>not</strong> a licensed electrician, electrical engineer,
              or certified installer.
            </p>
            <p>
              Work involving 12V, 24V, or 48V DC systems, solar panels and PV
              arrays, high‑voltage battery storage, and grid‑connected AC power,
              including split‑phase, single‑phase, or multi‑phase systems,
              presents inherent risks such as electrical fire, shock,
              electrocution, property damage, and personal injury.{" "}
              <strong>
                By accessing or using any content you acknowledge and assume all
                such risks
              </strong>{" "}
              and agree that any wiring, modifications, or installations you
              undertake are performed{" "}
              <strong>entirely at your own risk and responsibility</strong>.
            </p>
            <p>
              Electrical codes, safety regulations, and grid‑interconnection
              requirements vary by jurisdiction and utility provider. Certain
              work may require permits, inspections, utility approval, or
              installation by a licensed professional. Always verify technical
              specifications with official manufacturer documentation, comply
              with applicable codes and regulations, and consult a qualified,
              licensed electrician before performing any electrical work.
            </p>
            <p>
              <strong>No Warranties:</strong> All content is provided “as is”
              and without warranties of any kind, express or implied, including
              but not limited to warranties of merchantability, fitness for a
              particular purpose, or non‑infringement.
            </p>
            <p>
              <strong>Limitation of Liability & Indemnity:</strong> To the
              fullest extent permitted by law, Tyson's Gear Lab and its creators
              disclaim all liability for any direct, indirect, incidental,
              special, consequential, punitive, or regulatory damages, losses,
              fines, or injuries arising from the use or misuse of information
              published or distributed by Tyson's Gear Lab on any platform. You
              agree to release, indemnify, defend, and hold harmless Tyson's
              Gear Lab, its owners, contributors, and affiliates from any
              claims, liabilities, damages, costs, or expenses, including
              reasonable attorneys’ fees, arising out of your use of the content
              or any work you perform based on it.
            </p>
            <p>
              <strong>Severability:</strong> If any provision of this disclaimer
              is held invalid or unenforceable, the remaining provisions will
              remain in full force and effect.
            </p>

            <h2>General Content & Accuracy Disclaimer</h2>
            <p>
              All product information, specifications, testing results,
              comparisons, and technical guides are provided for general
              informational purposes and may contain errors, omissions, or
              outdated details. Product performance, safety characteristics, and
              results may vary based on equipment, environment, installation
              quality, or user skill.
            </p>
            <p>
              Mention of any product, brand, or manufacturer does not constitute
              endorsement. Content should not be relied upon as legal,
              financial, tax, medical, or professional engineering advice.
              Always verify specifications directly with manufacturers and
              consult qualified professionals when making decisions involving
              safety, compliance, or financial risk.
            </p>
            <p>
              Third‑party links are provided for convenience. Tyson's Gear Lab
              is not responsible for external content, policies, or practices.
            </p>
            <p>
              To the fullest extent permitted by law, Tyson's Gear Lab disclaims
              all liability for any direct, indirect, incidental, special,
              consequential, or regulatory damages arising from reliance on or
              use of any content. You agree to release, indemnify, defend, and
              hold harmless Tyson's Gear Lab and its creators from any claims or
              losses related to your use of the site or any actions you take
              based on its content.
            </p>

            <hr />

            <p>
              For site terms, conditions, and liability limitations, please
              review our <Link href={namedRoutes.terms}>Terms of Use</Link> and{" "}
              <Link href={namedRoutes.privacy}>Privacy Policy</Link>.
            </p>
          </Editorial>
        </div>
      </Popup>
    );
  };

  return (
    <Fragment>
      <p class={style.disclosure}>
        <strong>Disclaimer:</strong> I'm a DIY enthusiast, not a licensed
        electrician. Content is informational. I accept no liability for
        mistakes.{" "}
        <Link href="#" onClick={(e) => openDetails(e)}>
          More info
        </Link>
      </p>
    </Fragment>
  );
};

export default ElectricalDisclosure;
